export const SETDASHBOARDVALUE = "SETDASHBOARDVALUE";
export const SETDASHBOARDCOUNT = "SETDASHBOARDCOUNT";
export const SETDASHBOARDOUTSTANDING = "SETDASHBOARDOUTSTANDING";
export const SETDASHBOARDTOPOUTSTANDINGCUSTOMER = "SETDASHBOARDTOPOUTSTANDINGCUSTOMER";